import { withTranslation /* , i18n */ } from 'server/i18n'
import { NextSeo } from 'next-seo'
import PropTypes from 'prop-types'
import { Box } from 'reflexbox'
import getConfig from 'next/config'

import layoutTheme from 'theme/layout-theme'
import PageTitle from 'components/PageTitle'
import PromoBlock from 'components/PromoBlock'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL, DOMAIN_ROOT } = publicRuntimeConfig

const PrivacyPolicy = ({ canonical, t, i18n }) => {
    const seoData = {
        title: `${t('newsletter')} | Merk & Merk`,
        description: t('newsletter-subscribe-text'),
        canonical: t('meta-data:newsletter-url'),
        openGraph: {
            title: `${t('newsletter')} | Merk & Merk`,
            description: t('newsletter-subscribe-text'),
            url: t('meta-data:newsletter-url'),
            images: [
                {
                    url: `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                }
            ]
        },
        languageAlternates: [
            {
                hrefLang: 'en',
                href: `${DOMAIN_ROOT}/newsletter`
            },
            {
                hrefLang: 'de',
                href: `${DOMAIN_ROOT}/de/newsletter`
            }
        ]
    }

    return (
        <main>
            <NextSeo {...seoData} />
            <Box
                theme={layoutTheme}
                mt={[80, null, null, 140]}
                mb={[30, null, null, 80]}
                maxWidth={1280}
                px={40}
                mx="auto">
                <PageTitle title={t('newsletter')} titleTag="h1" />
            </Box>

            <Box theme={layoutTheme} px={20} mt={[80, null, null, 140]} mb={[80, null, null, 140]} variant="center1600">
                <PromoBlock
                    image="/images/message-in-bottle.jpg"
                    subtitle={t('newsletter-subscribe-text')}
                    newsletter
                    newsletterPlaceholder={t('placeholder-subscribe')}
                />
            </Box>
        </main>
    )
}

PrivacyPolicy.getInitialProps = async ({ req: { i18n } = {} }) => {
    return {
        canonical: i18n ? i18n.getFixedT('en')('meta-data:newsletter-url') : undefined,
        namespacesRequired: ['common', 'meta-data']
    }
}

PrivacyPolicy.propTypes = {
    canonical: PropTypes.string,
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    t: PropTypes.func.isRequired
}

PrivacyPolicy.defaultProps = {
    canonical: undefined
}

export default withTranslation('common', 'meta-data')(PrivacyPolicy)
